
import { Link } from "react-router-dom";
import nine from "../../Images/nine.png";
import eightythree from "../../Images/eightythree.jpg";
import eightyfour from "../../Images/eightyfour.jpg";
import { FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa";






export default function EmergencyDentist() {
  return (
    <>
    <div
  className=" relative w-full min-h-[300px] sm:min-h-[400px] lg:min-h-[350px]
    bg-cover bg-[center_50%] flex items-center pt-28 sm:pt-32 "
  style={{ backgroundImage: `url(${nine})` }}
>
  {/* Dark Overlay */}
  <div className="absolute inset-0 bg-black/55"></div>

  {/* Content */}
  <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <h1
      className=" text-white font-extrabold text-center text-3xl sm:text-2xl md:text-3xl lg:text-3xl xl:text-4xl
        leading-tight pt-5 pb-1 max-w-5xl -mt-12 sm:mt-0 mx-auto drop-shadow-[0_6px_20px_rgba(0,0,0,0.7)]" >
      Emergency Dentist In Khanewal
    </h1>
  </div>
  </div>

<div className=" px-3 py-16">
  <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-4 items-center">
    
    {/* LEFT CONTENT */}
    <div>
      <h2 className="text-3xl font-semibold text-[#0B1C6D] mb-4">
        Dental Injuries
      </h2>

      <p className="text-gray-600 leading-relaxed mb-2">
        More often than others, dental crises arise. One of the most frequent dental
        emergencies is tooth loss, which frequently occurs as a result of an accident
        or sports injury. You might shatter or chip a tooth while eating anything hard,
        necessitating immediate dental care. It’s also typical to get oral trauma in an
        accident and require emergency care. Other frequent dental injury emergencies
        include the following:
      </p>

      <ul className="list-disc pl-5 ml-5 text-gray-700">
        <li>A <span className="text-[#0aa6ff] font-medium">fractured tooth</span></li>
        <li>Knocking a tooth through direct impact</li>
        <li>Dental avulsion, or completely losing a tooth</li>
      </ul>
    </div>

    {/* RIGHT IMAGE */}
      <div className="w-full h-full rounded-2xl object-cover">
        <img
          src={eightythree}
          alt="Dental Injury"
          className="w-full h-full object-cover"
        />
      </div>
  </div>
</div>

<div className="bg-[#f5f9fc] px-3 py-16">
  <div className="max-w-7xl mx-auto ">
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center">
      
      {/* Left Image */}
      <div className="w-full h-full object-cover rounded-2xl">
        <img
          src={eightyfour}
          alt="Dental Emergency"
          className="w-full h-full object-cover"
        />
      </div>

      {/* Right Content */}
      <div>
        <h2 className="text-3xl font-bold px-3 text-[#0a0a5c] mb-4">
          Common Emergency Symptoms
        </h2>

        <p className="text-gray-700 mb-0 px-3 leading-relaxed">
          Dental crises can be excruciatingly painful and disruptive. They
          frequently occur suddenly and put you through a lot of stress. You
          may not feel any pain in some circumstances, but you still need
          emergency care. Always pay attention to any odd symptoms you
          experience in your mouth. The following are the warning symptoms of a
          dental emergency:
        </p>

        <ul className="list-disc pl-10 text-gray-700">
          <li>
            <span className="text-[#0aa6ff] font-semibold">Toothache</span> or sudden tooth pain
          </li>
          <li>Swelling around your jaw or mouth</li>
          <li>pus discharge</li>
          <li>fever</li>
          <li>tender to touch</li>
        </ul>

        <p className=" text-gray-800 px-3 font-medium mt-0">
          Book a dentist appointment immediately for a dental emergency.
        </p>
      </div>

    </div>
  </div>
</div>

<div className="max-w-7xl mx-auto px-3 py-16">
  
  {/* Top Paragraph */}
  <p className="text-gray-700 mb-12 leading-relaxed">
    Do you experience pain? Do you have a dental emergency such as{" "}
    <span className="text-[#0aa6ff] font-medium">toothache</span> or dental
    injuries like{" "}
    <span className="text-[#0aa6ff] font-medium">missing teeth</span> from
    sports? Other dental emergencies can include{" "}
    <span className="text-[#0aa6ff] font-medium">fractured teeth</span>,
    fillings, or facial swelling.
  </p>

  {/* Heading */}
  <h2 className="text-3xl font-bold text-center text-[#0a0a5c] mb-10">
    FAQs
  </h2>

  {/* FAQ Grid */}
  <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4">
    
    {/* Left Column */}
    <div className="space-y-2 items-center">
      {[
        "How much does it cost for emergency dental treatment?",
        "What can I do to help with the pain from a dental injury?",
        "When to get an emergency dentist appointment?",
        "What are the emergency conditions for dentistry?",
        "What should you do when a tooth falls out?",
      ].map((item, index) => (
        <div
          key={index}
          className="flex items-center gap-4 bg-[#5CB5B5] px-1 py-1 cursor-pointer transition-all duration-300 hover:bg-[#4a9a9a]"
        >
          <span className="text-2xl font-bold">+</span>
          <p className="font-medium leading-snug mt-3">
            {String(index + 1).padStart(2, "0")}. {item}
          </p>
        </div>
      ))}
    </div>

    {/* Right Column */}
    <div className="space-y-2">
      {[
        "What do you do if you fracture, chip or break a tooth?",
        "How can you prevent a dental emergency?",
        "What is the primary cause of most dental emergencies?",
        "Can an emergency dentist extract a tooth?",
      ].map((item, index) => (
        <div
          key={index}
          className="flex items-center gap-4 bg-[#5CB5B5] px-1 py-1 cursor-pointer transition-all duration-300 hover:bg-[#4a9a9a] "
        >
          <span className="text-2xl font-bold">+</span>
          <p className="font-medium leading-snug mt-3">
            {String(index + 6).padStart(2, "0")}. {item}
          </p>
        </div>
      ))}
    </div>

  </div>
</div>

<div className="w-full h-[180px] overflow-hidden mt-4">
  <iframe
    title="clinic-map"
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3445.0390050498395!2d71.9162331!3d30.292951199999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x393b557588a60575%3A0x79afa5462675bee1!2sSmile%20expert%20dental%20clinic!5e0!3m2!1sen!2s!4v1767274320473!5m2!1sen!2s"
    width="100%"
    height="450"
    style={{ border: "0" }}
    allowFullScreen
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
  />
</div>

<div className="bg-[#0c2340] text-white pt-[60px] pb-[60px] px-[40px] mt-0">
  <div className="flex justify-between flex-wrap max-w-[1400px] mx-auto gap-[40px]">
    {/* COLUMN 1 */}
    <div className="min-w-[200px]">
  <h3 className="text-[20px] mb-[20px]">Useful Links</h3>

  <Link to="/about/meet-our-team" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    About Us
  </Link>

  <Link to="/contact" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Contact Us
  </Link>

  <Link to="/about/meet-our-team" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Meet the Team
  </Link>

  <Link to="/teeth-whitening-before-and-after" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Before & After
  </Link>

  <Link to="/blog" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Blogs
  </Link>
</div>


    
    <div className="min-w-[200px]">
  <h3 className="text-[20px] mb-[20px]">Treatments</h3>

  <Link to="/treatment/exam" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Exam & X-Rays Check-Up
  </Link>

  <Link to="/emergency-dentist" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Dental Emergency
  </Link>

  <Link to="/t/implants" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Smile Makeover
  </Link>

  <Link to="/t/veneer" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Veneers
  </Link>

  <Link to="/t/implants" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Dental Implants
  </Link>

  <Link to="t/canals" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Root Canal Treatment
  </Link>

  <Link to="/t/orthodontist" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Orthodontic Braces
  </Link>

  
</div>


    <div className="min-w-[200px]">
  <h3 className="text-[20px] mb-[20px]">Dental Problems</h3>

  <Link to="/yellow-teeth-treatment" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Yellow Teeth
  </Link>

  <Link to="/teeth-cleaning" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Teeth Cleaning
  </Link>

  <Link to="/missing-teeth-treatment" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Missing Teeth
  </Link>

  <Link to="/broken-chipped-tooth" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Broken Chipped Tooth
  </Link>

  <Link to="/gum-disease" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Gum Disease
  </Link>

  <Link to="/crooked-teeth-treatment" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Crooked Teeth
  </Link>

  <Link to="/sore-teeth-treatment" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Sensitive & Sore Teeth
  </Link>

  <Link to="/dental-anxiety" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Dental Anxiety
  </Link>
</div>


    <div className="min-w-[200px]">
  <h3 className="text-[20px] mb-[20px]">Patient Safety</h3>

  <Link to="/7x-safety" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    7X SAFETY
  </Link>

  <Link to="/4-step-sterilization" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    4 Step Sterilization
  </Link>

  <Link to="/safety-equipment" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Safety Equipment
  </Link>

  <Link to="/equipment-technology" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Equipment & Technology
  </Link>

  <Link to="/quality" className="block my-[6px] text-inherit no-underline hover:text-blue-600">
    Quality
  </Link>
</div>


    <div className="min-w-[250px]">
              <h3 className="text-[20px] mb-[20px]">Get in touch</h3>
        
              <p className="my-2 flex gap-[10px] ">📧 aneelabrar555@gmail.com</p>
        
              <p className="my-3 flex gap-[10px]  ">📞 03008395562</p>
        
              <p className="my-2 flex gap-[10px] px-2">
                  <span className="">📍 Saddique Hospital Stadium Road Khanewal</span>
              </p>
        
              <p className="mt-6 font-semibold "> 🕒 Clinic Timing <br/>   <span className="ml-7">11:00am to 9:00pm</span></p>
        
              <div className="text-left bg-[#0c2340] text-white py-[50px] px-[20px]">
                <div className="flex gap-[15px] mt-[20px]">
                  <a

                      href="https://www.facebook.com/share/17zJppb7qh/"

                      target="_blank"

                      rel="noopener noreferrer"

                      className="w-[35px] h-[35px] bg-blue-900 flex justify-center items-center rounded-[8px] no-underline"

                      aria-label="Follow us on Facebook"

                    >

                      <FaFacebookF size={20} color="white" />
                  </a>
        
                  <a

        
                      href="https://instagram.com"

        
                      target="_blank"

        
                      rel="noopener noreferrer"

        
                      className="w-[35px] h-[35px] bg-[#000000] flex justify-center items-center rounded-[8px] no-underline"

        
                      aria-label="Follow us on Instagram"

        
                    >

        
                      <FaInstagram size={20} color="white" />
                  </a>
        
                  <a

        
                      href="https://youtube.com"

        
                      target="_blank"

        
                      rel="noopener noreferrer"

        
                      className="w-[35px] h-[35px] bg-[#FF0000] flex justify-center items-center rounded-[8px] no-underline"

        
                      aria-label="Subscribe to our YouTube channel"

        
                    >

        
                      <FaYoutube size={22} color="white" />
                  </a>
                </div>
              </div>
            </div>
    
  </div>
   <div className="w-full text-center justify-end mb-0 border-t border-gray-300 pt-4">
  <p className="text-sm text-gray-400">
    © SmileExpert
    <span className="mx-2 text-gray-600">|</span>
    Powered by{" "}
    <a
      href="https://verdant-soft.com/"
      target="_blank"
      rel="noopener noreferrer"
      className="text-gray-300 hover:text-blue-400 no-underline font-medium transition-colors duration-300 "
    >
      Verdant Soft
    </a>
  </p>
</div>

</div>





    </>
)
}








